import { Component, h, Prop, Host, State, Watch } from "@stencil/core";
import { ServiceCallsResponse } from "./service-calls-response";
import api from "../../utils/api";

@Component({
    tag: "ux-w-service-calls",
    styleUrl: "service-calls.scss",
    shadow: false
})
export class ServiceCalls {
    /** URL where this widget can request the data */
    @Prop() url: string = "";
    /** This holds the response from the API with all Information required to show the widget */
    @State() data: ServiceCallsResponse = null;
    /** data is loading */
    @State() loading: boolean = false;

    @Watch("url")
    componentWillLoad() {
        if (this.url === "") {
            // eslint-disable-next-line no-console
            console.warn("url needs to be supplied for WidgetServiceCalls");
            return;
        }
        window.setTimeout(() => {
            if (this.data === null) {
                this.loading = true;
            }
        });
        api<ServiceCallsResponse>(this.url)
            .then((data: ServiceCallsResponse) => {
                this.data = data;
                this.loading = false;
            })
            // eslint-disable-next-line no-console
            .catch((error) => console.error(error));
    }

    render() {
        const baseClass = "ux-w-service-calls";
        if (this.loading) {
            return (
                <Host class={baseClass}>
                    <ux-w-wrapper isLoading />
                </Host>
            );
        }
        if (this.data === null) {
            return null;
        }
        const {
            link,
            linkTitle,
            title,
            noCallsText,
            createCall,
            createCallLink,
            messages,
            noData,
            noDataText,
            isCaseOverviewAllowed
        } = this.data;

        const hasCalls = this.data?.calls?.length > 0;

        const calls = hasCalls
            ? [...this.data.calls]
                  .map((call) => {
                      if (
                          call.unreadChatMessages &&
                          call.unreadChatMessages > 0
                      ) {
                          call.status.text = messages?.unreadChatMessagesText;
                      }
                      return call;
                  })
                  .sort((a, b) => b.unreadChatMessages - a.unreadChatMessages)
            : null;

        return (
            <Host class={baseClass}>
                <ux-w-wrapper url={link} linkTitle={linkTitle} headline={title}>
                    <div slot="content">
                        {!isCaseOverviewAllowed && (
                            <ux-w-empty icon="cross" class="ux-color-error">
                                <div
                                    innerHTML={messages?.disabledOverviewText}
                                ></div>
                            </ux-w-empty>
                        )}
                        {!hasCalls && !noData && isCaseOverviewAllowed && (
                            <ux-w-empty
                                link={createCallLink}
                                linkText={createCall}
                                icon="hand-list-arrow"
                            >
                                <div innerHTML={noCallsText}></div>
                            </ux-w-empty>
                        )}
                        {!hasCalls && noData && isCaseOverviewAllowed && (
                            <ux-w-empty icon="crane">
                                <div innerHTML={noDataText}></div>
                            </ux-w-empty>
                        )}
                        {isCaseOverviewAllowed &&
                            calls?.map((call) => {
                                /** @deprecated */
                                const hasUnreadChatMessages =
                                    call.unreadChatMessages &&
                                    call.unreadChatMessages > 0;

                                return (
                                    <div class={`${baseClass}__item`}>
                                        <ux-w-service-calls-item
                                            headline={call.title}
                                            statusType={call.status?.type}
                                            statusText={
                                                hasUnreadChatMessages
                                                    ? messages.unreadChatMessagesText
                                                    : call.status?.text
                                            }
                                            unreadMessages={
                                                call.unreadChatMessages
                                            }
                                            machineName={call.machineName}
                                            machineNumber={call.machineNumber}
                                            lastChange={call.lastChange}
                                            lastChangeLabel={
                                                messages?.lastChange
                                            }
                                            callIdLabel={messages?.callId}
                                            callId={call.callId}
                                            link={call.link}
                                            linkTitle={messages?.details}
                                            timeFormat={messages?.timeFormat}
                                        ></ux-w-service-calls-item>
                                    </div>
                                );
                            })}
                    </div>
                </ux-w-wrapper>
            </Host>
        );
    }
}
